var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtnImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71884",
    "data-name": "Group 71884",
    transform: "translate(-223 -619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_19076",
    "data-name": "Rectangle 19076",
    transform: "translate(223 619)",
    fill: "#fff",
    stroke: "rgba(7,36,48,0.4)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M6.4,12.044a.614.614,0,0,0,.868,0l1.952-1.952,1.952,1.952a.614.614,0,0,0,.868-.868L10.092,9.224l1.952-1.952a.614.614,0,0,0-.868-.868L9.223,8.355,7.272,6.4a.614.614,0,0,0-.868.868L8.355,9.224,6.4,11.175a.614.614,0,0,0,0,.868Z",
    transform: "translate(223.776 619.776)",
    fill: "#072430"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtnImg);
export default __webpack_public_path__ + "static/media/close-btn-img.08e60b44b3379af26017fb1e05b838f0.svg";
export { ForwardRef as ReactComponent };